export const COLORS = {
  UPTIME: '#41B900',
  DOWNTIME: '#C2272D',
  NO_MONITOREO: '#A9A9A9',
  DOWNTIME_PARCIAL: '#FFC600',
  EVENTO_CLIENTE: '#1976d2',
  MARCADO_ATENTUS: '#59adff',
};
